import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useEffect} from 'react';

import Background from '../../assets/images/create_project_bg.png';
import {FlatDetailsComponent} from './FlatDetailsComponent';
import {FlatsListComponent} from './FlatsListComponent';
import {useParams} from 'react-router-dom';
import {AppRoutes} from '../../routing/AppRoutes';
import {FlatListForLogGenericState, FlatListGroup} from './FlatListForLogGenericState';

export interface FlatListWithDetailsComponentProps {
    flatListGroup?: FlatListGroup;
    state: FlatListForLogGenericState;
}

export const FlatListWithDetailsComponent: FC<FlatListWithDetailsComponentProps> = observer(
    ({state, flatListGroup}) => {
        const {flatId} = useParams();
        let {logId} = useParams();

        if (!logId && flatListGroup) {
            logId = flatListGroup;
        }

        useEffect(() => {
            document.onkeydown = function(e) {
                if (!state) {
                    return;
                }
                switch (e.which) {
                    case 37:
                        state.previousFlat();
                        break;
                    case 39:
                        state.nextFlat();
                        break;
                    default:
                        return; // exit this handler for other keys
                }
                e.preventDefault(); // prevent the default action (scroll / move caret)
            };
            return () => {
                document.onkeydown = null;
            };
        }, [state]);

        useEffect(() => {
            if (!logId) {
                throw new Error('No log id');
            }

            state.setCurrentLog(logId, flatId);
        }, [logId, flatId]);


        const list = state.log ? <FlatsListComponent
            state={state}
        /> : undefined;

        return (
            <div
                style={
                    (state.route === AppRoutes.Assigned || state.route === AppRoutes.Starred) && state.log?.total === 0
                        ? {
                            backgroundImage: `url(${Background})`,
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            height: '100%',
                        }
                        : {}
                }
            >
                <div className="gap-4 grid grid-cols-12">
                    {state.log?.total === 0 && (
                        <div className="block md:hidden col-span-12">
                            {list}
                        </div>
                    )}
                    <div data-tut="flatlist" className="hidden md:block col-span-6 xl:col-span-5">
                        {list}
                    </div>
                    <div className="col-span-12 md:col-span-6 xl:col-span-7">
                        <FlatDetailsComponent state={state}/>
                    </div>
                </div>
            </div>
        );
    },
);
